<template>
  <div class="login">
    <div class="container">
      <h1>账号登陆</h1>

      <div class="error"> {{ error_msg }} </div>
      <div class="form" name="loginForm">
        <input v-model="username" type="text" placeholder="请输入用户名/手机号">
        <input v-model="password" type="password" placeholder="请输入密码">
        <button class="btn-login" @click="Login">登录</button>
      </div>
    </div>
    <p class="copyright">©2023 Powered by extended-gin</p>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',
      error_msg: ''
    }
  },
  methods: {
    async Login () {
      this.error_msg = ''
      let headers = {'Content-Type': 'application/x-www-form-urlencoded'}
      await this.$api.login.login(
        {username: this.username, password: this.password},
        {headers: headers}).then(res => {
        if (res.result) {
          window.location.href = window.location.origin
        } else {
          this.error_msg = res.msg
        }
      })
    }
  }
}
</script>

<style scoped>

.login{
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* 渐变背景 */
  /*background: linear-gradient(to top left,#ffe29f,#ffa99f,#ff719a);*/
  background: linear-gradient(to top left, #6486d8, #858bd5, #b1a5d6, #9facde, #6eaee5);
  overflow: hidden;
}

.container {
  text-align: center;
  color: #fff;

  width: 30%;
  /*height: 400px;*/
  background-color: rgba(255, 255, 255, 0.2);
  margin: auto;
  border-radius: 12px;
  padding: 50px 0 100px 0;
}

.container h1 {
  font-size: 30px;
  font-weight: 200;
  letter-spacing: 1px;
  margin-bottom: 15px;

  transition: 1s ease-in-out;
}

.error {
  font-size: 14px;
  color: orangered;
  text-align: center;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  opacity: 1;
  /* 不透明度改变时的过渡效果 */
  transition: opacity 0.5s;
}

.form input {
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background-color: rgba(255, 255, 255, 0.4);
  width: 60%;
  padding: 10px 15px;
  border-radius: 3px;
  margin: 0 auto 10px auto;
  text-align: center;
  color: #fff;
  font-size: 15px;
  transition: 0.25s;
}

.form input::placeholder {
  color: #fff;
  font-size: 14px;
  font-weight: 300;
}

.form input:hover {
  background-color: #fff;
  color: #6486d8;
}

.form input:focus {
  background-color: #fff;
  width: 70%;
  color: #6486d8;
}

.btn-login {
  outline: none;
  background-color: #fff;
  color: #6486d8;
  border: none;
  width: 60%;
  padding: 10px 15px;
  border-radius: 3px;
  font-size: 15px;
  cursor: pointer;
  transition: 0.25s;
}

.btn-login:hover {
  background-color: #f5f7f9;
}

.copyright {
  font-size: 10px;
  color: #fff;
  position: fixed;
  bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue